import React from "react";
import "../Grids/Grids.css";

const instruments = [
  {
    name: "Bone Cutter",
    image: "/bc.webp",
  },
  {
    name: "Retractor",
    image: "/rt.webp",
  },
  {
    name: "Drill",
    image: "/drill.webp",
  },
  {
    name: "Screw Driver",
    image: "/sd.webp",
  },
  {
    name: "Bone Plate",
    image: "/bp.webp",
  },
  {
    name: "Wire Cutter",
    image: "/wc.webp",
  },
];

const InstrumentsGrid = () => {
  return (
    <section className="instruments-section">
      <h2 className="section-title">Types Of Orthopedic Packaging</h2>
      <div className="grid-container">
        {instruments.map((instrument, index) => (
          <div className="card" key={index}>
            <div className="name-bar">
              <span>{instrument.name}</span>
            </div>
            <img
              src={instrument.image}
              alt={instrument.name}
              className="instrument-image"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default InstrumentsGrid;
